import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, createBlock as _createBlock, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, isRef as _isRef, resolveDirective as _resolveDirective, withDirectives as _withDirectives, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-460875cd"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "mb-10"
}
const _hoisted_2 = /*#__PURE__*/_createTextVNode("确认此月考勤")
const _hoisted_3 = { class: "mt-10" }
const _hoisted_4 = /*#__PURE__*/_createTextVNode("当月总结")
const _hoisted_5 = /*#__PURE__*/_createTextVNode("扣款金额(元)")
const _hoisted_6 = { key: 1 }
const _hoisted_7 = { class: "mt-10 getMessageContent" }
const _hoisted_8 = {
  key: 0,
  class: "mb-10"
}
const _hoisted_9 = /*#__PURE__*/_createTextVNode(" 获取短信验证码 ")
const _hoisted_10 = { key: 0 }
const _hoisted_11 = /*#__PURE__*/_createTextVNode(" 获取邮箱验证码 ")
const _hoisted_12 = { key: 0 }
const _hoisted_13 = {
  key: 2,
  class: "mb-10"
}
const _hoisted_14 = {
  key: 3,
  class: "mt-10"
}
const _hoisted_15 = {
  key: 4,
  class: "mt-10"
}
const _hoisted_16 = /*#__PURE__*/_createTextVNode("取消")
const _hoisted_17 = /*#__PURE__*/_createTextVNode("确认")

import { ref, computed, reactive, onMounted } from 'vue'
import dayjs from 'dayjs'
import { useStore } from 'vuex'
import { ElMessage, ElMessageBox } from 'element-plus'
import tbMix from '@/global_mixin/tableMixin'
import { getNumber } from '@/utils/index'
import Api from '@/http/modules/index'

export default /*#__PURE__*/_defineComponent({
  setup(__props) {

let {
  // 根据用户获取考勤信息
  'POST/checkin': fetchList,
  // 确认考勤（个人）
  'PATCH/checkin/user_verify': user_verifyApi,
  // 个人扣款详情
  'POST/checkin/individual/deduct_money': deduct_moneyApi,
  // 发送短信验证码(已登录状态)
  'GET/sms/purpose': purposeApi,
  // 发送邮件验证码
  'GET/mail/send_code': send_codeApi,
} = Api

const store = useStore()
// 判断时间是否为当前五号，
let searchDate = computed(() => {
  return dayjs().date() < 5 ? dayjs().subtract(1, 'month').format('YYYY-MM') + '-01' : dayjs().subtract(0, 'month').format('YYYY-MM') + '-01'
})
const searchObj = reactive({
  date: searchDate.value
})

const lockby = ref<boolean>(false)
let attendenceDetail: any = reactive({})
const searchHandle = async (params: any) => { 
  fetchData({userId: store.getters.userId, ...params}).then((rep) => {
    Object.assign(attendenceDetail, rep.detail|| {leave: '', late: '', fullAttendance: ''})
    lockby.value = rep.lockBy === null ? true : false
  })
}
onMounted(() => {

  searchHandle(searchObj)
})

let { 
  MI_height, MI_tableData,  fetchData,  
  MI_identify, MI_params, MI_modifyForm
} = new tbMix(fetchList)

const formatJudgment = (row: any, column: any, cellValue: number, index: number) => {
  if ((dayjs(row.date).day() === 0 || dayjs(row.date).day() === 6) &&
    row.earliestTime === '00:00:00' &&
    row.lastestTime === '00:00:00' &&
    row.judgment === "正常") return '';
  return cellValue
}
const formatStartTime = (row: any, column: any, cellValue: number, index: number) => {
  if (!row.details) return '-';
  let arr = row.details.reduce((arr: Array<any>, _time: any) => {
    arr.push(_time.startTime)
    return arr
  }, [])
  arr.sort((a: string, b: string) => {
    return dayjs(a, 'HH:mm:ss').isBefore(dayjs(b, 'HH:mm:ss')) ? -1 : 1
  })
  if (arr.length === 0) {
    return '-'
  }
  if (arr.length === 1 && arr[0] === '00:00:00') {
    return '00:00'
  }
  if (arr.length > 1 && arr[0] === '00:00:00') {
    return dayjs(arr[1], 'HH:mm:ss').format('HH:mm')
  }
  return dayjs(arr[0], 'HH:mm:ss').format('HH:mm')

}
const formatEndTime = (row: any, column: any, cellValue: number, index: number) => {
  if (row.details) {

    let arr = row.details.reduce((arr: Array<any>, _time: any) => {
      _time.endTime !== '00:00:00' ? arr.push(_time.endTime) : arr.push('00:00:00')
      return arr
    }, [])
    arr.sort((a: string, b: string) => {
      return dayjs(a, 'HH:mm:ss').isBefore(dayjs(b, 'HH:mm:ss')) ? 1 : -1
    })

    return dayjs(arr[0], 'HH:mm:ss').format('HH:mm')
  }


  return '-'
}

// 个人确认考勤
const isShowConfirm = ref<boolean>(false)
let dudectObj: any = reactive({})
let balanceObj: any = reactive({})
const showConfirm = () => {
  MI_identify.value = true
  deduct_moneyApi({
    date: MI_params.date,
    userId: store.getters.userId,
  }).then(rep => {
    Object.assign(dudectObj, rep.deduct)
    Object.assign(balanceObj, rep.balance)
    MI_identify.value = false
    isShowConfirm.value = true
  }).catch(() => [
    MI_identify.value = false
  ])
}

let code = ref('')
let targetAddr = ref<string>('')
let disabledCode = ref<boolean>(false)
let countDown = ref<number>(60)

const disabledPhone = ref<boolean>(false)
const disabledMail = ref<boolean>(false)

const getCodeHandle = () => {
  disabledPhone.value = true
  purposeApi({purpose: 'CheckinConfirm'}).then((rep) => {
    disabledCode.value = true
    ElMessage.success('发送成功')
    targetAddr.value = (rep as {phone: string}).phone.slice(-4);
    // 倒计时六十秒
    let intervalId = setInterval(() => {
      countDown.value = countDown.value -1
      if(countDown.value === 0){
        countDown.value = 60
        disabledCode.value = false
        disabledPhone.value = false
        clearInterval(intervalId)
      }
    }, 1000)
  })
}
const getMailCodeHandle = () => {
  disabledMail.value = true
  send_codeApi({purpose: 'CheckinConfirm'}).then((rep) => {
    disabledCode.value = true
    ElMessage.success('发送成功')

    targetAddr.value = (rep as {email: string}).email
    // 60秒倒计时
    let intervalId = setInterval(() => {
      countDown.value = countDown.value -1
      if(countDown.value === 0){
        countDown.value = 60
        disabledCode.value = false
        disabledMail.value = false
        clearInterval(intervalId)
      }
    }, 1000)
  })
}

const isConfirmLoadingFg = ref<boolean>(false)
const confirmHandle = async () => {
  if(!code){
    ElMessage.warning('请检查验证码输入')
    return
  }
  isConfirmLoadingFg.value = true
  try {
    await user_verifyApi({ userId: store.getters.userId, date: MI_params.date, code: code.value })
    ElMessage.success('确认成功')
    isConfirmLoadingFg.value = false
    isShowConfirm.value = false
    searchHandle(MI_params)
  } catch (error) {
    isConfirmLoadingFg.value = false
  }
}

// ------------
const tableRowClassName = ({ row, rowIndex }: { row: any, rowIndex: number }) => {
  if (
    (dayjs(row.date).day() === 0 || dayjs(row.date).day() === 6) &&
    row.earliestTime === '00:00:00' &&
    row.lastestTime === '00:00:00' &&
    row.judgment === "正常") {
    return 'holiday-row'
  }
  return ''
}

const isMobile = computed(() => window.innerWidth <= 768)


return (_ctx: any,_cache: any) => {
  const _component_el_date_picker = _resolveComponent("el-date-picker")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_table_column = _resolveComponent("el-table-column")!
  const _component_el_table = _resolveComponent("el-table")!
  const _component_el_divider = _resolveComponent("el-divider")!
  const _component_el_descriptions_item = _resolveComponent("el-descriptions-item")!
  const _component_el_tag = _resolveComponent("el-tag")!
  const _component_el_descriptions = _resolveComponent("el-descriptions")!
  const _component_el_alert = _resolveComponent("el-alert")!
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_scrollbar = _resolveComponent("el-scrollbar")!
  const _component_el_dialog = _resolveComponent("el-dialog")!
  const _directive_loading = _resolveDirective("loading")!

  return _withDirectives((_openBlock(), _createElementBlock("div", null, [
    _createVNode(_component_el_date_picker, {
      modelValue: _unref(searchObj).date,
      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_unref(searchObj).date) = $event)),
      type: "month",
      "value-format": "YYYY-MM-DD",
      placeholder: "Pick a month",
      clearable: false,
      class: "mr-10",
      onChange: _cache[1] || (_cache[1] = ($event: any) => (searchHandle(_unref(searchObj))))
    }, null, 8, ["modelValue"]),
    (_unref(isMobile))
      ? (_openBlock(), _createElementBlock("div", _hoisted_1))
      : _createCommentVNode("", true),
    (lockby.value)
      ? (_openBlock(), _createBlock(_component_el_button, {
          key: 1,
          type: "success",
          onClick: _cache[2] || (_cache[2] = ($event: any) => (showConfirm()))
        }, {
          default: _withCtx(() => [
            _hoisted_2
          ]),
          _: 1
        }))
      : _createCommentVNode("", true),
    _createVNode(_component_el_button, {
      onClick: _cache[3] || (_cache[3] = ($event: any) => (searchHandle(_unref(searchObj)))),
      type: "info",
      icon: "refresh"
    }),
    _createVNode(_component_el_table, {
      class: "mt-10",
      border: "",
      data: _unref(MI_tableData),
      "max-height": _unref(MI_height) - 108 + 'px',
      "row-class-name": tableRowClassName
    }, {
      default: _withCtx(() => [
        _createVNode(_component_el_table_column, {
          label: `日期${_unref(isMobile) ? '(左滑)': ''}`,
          prop: "date",
          width: "110",
          "show-overflow-tooltip": "",
          fixed: ""
        }, null, 8, ["label"]),
        (_unref(isMobile))
          ? (_openBlock(), _createBlock(_component_el_table_column, {
              key: 0,
              label: "判定",
              prop: "judgment",
              formatter: formatJudgment,
              "show-overflow-tooltip": "",
              width: "110"
            }))
          : _createCommentVNode("", true),
        _createVNode(_component_el_table_column, {
          label: "上班",
          width: "100",
          prop: "earliestTime"
        }, {
          default: _withCtx(({ row }) => [
            _createElementVNode("div", null, _toDisplayString(row.earliestTime === '00:00:00' ? '' : _unref(dayjs)(row.earliestTime, 'HH:mm:ss').format('HH:mm')), 1)
          ]),
          _: 1
        }),
        _createVNode(_component_el_table_column, {
          label: "下班",
          width: "100",
          prop: "lastestTime"
        }, {
          default: _withCtx(({ row }) => [
            _createElementVNode("div", null, _toDisplayString(row.lastestTime === '00:00:00' ? '' : _unref(dayjs)(row.lastestTime, 'HH:mm:ss').format('HH:mm')), 1)
          ]),
          _: 1
        }),
        _createVNode(_component_el_table_column, {
          label: "修正上班",
          width: "100",
          formatter: formatStartTime
        }),
        _createVNode(_component_el_table_column, {
          label: "修正下班",
          width: "100",
          formatter: formatEndTime
        }),
        (!_unref(isMobile))
          ? (_openBlock(), _createBlock(_component_el_table_column, {
              key: 1,
              label: "判定",
              prop: "judgment",
              formatter: formatJudgment,
              "show-overflow-tooltip": ""
            }))
          : _createCommentVNode("", true)
      ]),
      _: 1
    }, 8, ["data", "max-height"]),
    _createElementVNode("div", _hoisted_3, [
      _createVNode(_component_el_divider, { "content-position": "left" }, {
        default: _withCtx(() => [
          _hoisted_4
        ]),
        _: 1
      }),
      _createVNode(_component_el_descriptions, {
        title: "",
        border: "",
        column: _unref(isMobile) ? 1 : 4,
        direction: _unref(isMobile) ? 'vertical' : 'horizontal'
      }, {
        default: _withCtx(() => [
          _createVNode(_component_el_descriptions_item, { label: "考勤确认状态" }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(lockby.value ? '未确认': '已确认'), 1)
            ]),
            _: 1
          }),
          _createVNode(_component_el_descriptions_item, { label: "迟到分钟" }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_unref(attendenceDetail).late), 1)
            ]),
            _: 1
          }),
          _createVNode(_component_el_descriptions_item, { label: "缺勤(分钟)" }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_unref(attendenceDetail).leave), 1)
            ]),
            _: 1
          }),
          _createVNode(_component_el_descriptions_item, { label: "全勤状态" }, {
            default: _withCtx(() => [
              (_unref(attendenceDetail).fullAttendance !== '')
                ? (_openBlock(), _createBlock(_component_el_tag, {
                    key: 0,
                    size: "small"
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(_unref(attendenceDetail).fullAttendance ? '全勤' : '非全勤'), 1)
                    ]),
                    _: 1
                  }))
                : _createCommentVNode("", true)
            ]),
            _: 1
          })
        ]),
        _: 1
      }, 8, ["column", "direction"])
    ]),
    _createVNode(_component_el_dialog, {
      title: "考勤确认",
      width: _unref(isMobile) ? '95vw' : '600px',
      draggable: "",
      modelValue: isShowConfirm.value,
      "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((isShowConfirm).value = $event))
    }, {
      footer: _withCtx(() => [
        _createVNode(_component_el_button, {
          onClick: _cache[7] || (_cache[7] = ($event: any) => (isShowConfirm.value = false)),
          disabled: isConfirmLoadingFg.value
        }, {
          default: _withCtx(() => [
            _hoisted_16
          ]),
          _: 1
        }, 8, ["disabled"]),
        _createVNode(_component_el_button, {
          type: "success",
          onClick: _cache[8] || (_cache[8] = ($event: any) => (confirmHandle())),
          loading: isConfirmLoadingFg.value
        }, {
          default: _withCtx(() => [
            _hoisted_17
          ]),
          _: 1
        }, 8, ["loading"])
      ]),
      default: _withCtx(() => [
        _createVNode(_component_el_alert, {
          class: "mb-10",
          title: "请仔细核对考勤信息。若有任何疑问，及时联系HR核实。若无误，请点击确认键",
          type: "warning",
          effect: "dark",
          closable: false
        }),
        _createVNode(_component_el_scrollbar, {
          "max-height": _unref(isMobile) ? '50vh' : '70vh'
        }, {
          default: _withCtx(() => [
            _createVNode(_component_el_divider, { "content-position": "left" }, {
              default: _withCtx(() => [
                _createTextVNode("考勤详情 " + _toDisplayString(_unref(isMobile)? '(可向下滑动)': ''), 1)
              ]),
              _: 1
            }),
            (_unref(dudectObj).totalAmount !== 0)
              ? (_openBlock(), _createBlock(_component_el_descriptions, {
                  key: 0,
                  title: "",
                  border: "",
                  column: 1,
                  direction: _unref(isMobile) ? 'vertical' : 'horizontal'
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_descriptions_item, { label: "扣款项目" }, {
                      default: _withCtx(() => [
                        _hoisted_5
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_el_descriptions_item, {
                      label: '迟到早退(分钟):' + _unref(dudectObj).earlyLate
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(_unref(getNumber)(_unref(dudectObj).earlyLateAmount)), 1)
                      ]),
                      _: 1
                    }, 8, ["label"]),
                    _createVNode(_component_el_descriptions_item, {
                      label: '试用期病假(小时):' + _unref(dudectObj).periodSickHour
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(_unref(getNumber)(_unref(dudectObj).periodSickAmount)), 1)
                      ]),
                      _: 1
                    }, 8, ["label"]),
                    _createVNode(_component_el_descriptions_item, {
                      label: '试用期事假(小时):' + _unref(dudectObj).periodCompassionateHour
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(_unref(getNumber)(_unref(dudectObj).periodCompassionateAmount)), 1)
                      ]),
                      _: 1
                    }, 8, ["label"]),
                    _createVNode(_component_el_descriptions_item, {
                      label: '转正病假(小时):' + _unref(dudectObj).regularSickHour
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(_unref(getNumber)(_unref(dudectObj).regularSickAmount)), 1)
                      ]),
                      _: 1
                    }, 8, ["label"]),
                    _createVNode(_component_el_descriptions_item, {
                      label: '转正事假(小时):' + _unref(dudectObj).regularCompassionateHour
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(_unref(getNumber)(_unref(dudectObj).regularCompassionateAmount)), 1)
                      ]),
                      _: 1
                    }, 8, ["label"]),
                    _createVNode(_component_el_descriptions_item, { label: "总扣款(元)" }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(_unref(getNumber)(_unref(dudectObj).totalAmount)), 1)
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }, 8, ["direction"]))
              : (_openBlock(), _createElementBlock("div", _hoisted_6, "本月暂无扣款")),
            _createVNode(_component_el_divider, { "content-position": "left" }, {
              default: _withCtx(() => [
                _createTextVNode("截止至" + _toDisplayString(_unref(dayjs)().format('YYYY-MM-DD')) + " 剩余假期详情", 1)
              ]),
              _: 1
            }),
            _createVNode(_component_el_descriptions, {
              title: "",
              border: "",
              column: "1",
              direction: _unref(isMobile) ? 'vertical' : 'horizontal'
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_descriptions_item, { label: "年假剩余" }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_unref(balanceObj).annualDay <= 0 ? 0 : _unref(balanceObj).annualDay) + "天", 1)
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_descriptions_item, {
                  label: '调休假已过期：' + _unref(balanceObj).invailed / 8 + '(天)'
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_unref(balanceObj).invailed) + "小时", 1)
                  ]),
                  _: 1
                }, 8, ["label"]),
                _createVNode(_component_el_descriptions_item, {
                  label: '调休假总剩余：' + _unref(balanceObj).adjustDay / 8 + '(天)'
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_unref(balanceObj).adjustDay) + "小时", 1)
                  ]),
                  _: 1
                }, 8, ["label"])
              ]),
              _: 1
            }, 8, ["direction"]),
            _createElementVNode("div", _hoisted_7, [
              _createVNode(_component_el_alert, {
                title: "请输入短信或邮箱验证码以确认",
                type: "warning",
                closable: false,
                class: "mb-10"
              }),
              _createVNode(_component_el_input, {
                modelValue: _unref(code),
                "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => (_isRef(code) ? (code).value = $event : code = $event)),
                placeholder: "请输入验证码",
                class: "mr-10",
                maxlength: "20"
              }, null, 8, ["modelValue"]),
              (_unref(isMobile))
                ? (_openBlock(), _createElementBlock("div", _hoisted_8))
                : _createCommentVNode("", true),
              _createVNode(_component_el_button, {
                disabled: _unref(disabledCode),
                loading: !_unref(disabledCode) && disabledPhone.value,
                onClick: _cache[5] || (_cache[5] = ($event: any) => (getCodeHandle())),
                class: "getMeessageBtn",
                type: "primary"
              }, {
                default: _withCtx(() => [
                  _hoisted_9,
                  (_unref(disabledCode) && disabledPhone.value)
                    ? (_openBlock(), _createElementBlock("span", _hoisted_10, "(" + _toDisplayString(_unref(countDown)) + ")", 1))
                    : _createCommentVNode("", true)
                ]),
                _: 1
              }, 8, ["disabled", "loading"]),
              _createVNode(_component_el_button, {
                disabled: _unref(disabledCode),
                loading: !_unref(disabledCode) && disabledMail.value,
                onClick: _cache[6] || (_cache[6] = ($event: any) => (getMailCodeHandle())),
                class: "getMeessageBtn"
              }, {
                default: _withCtx(() => [
                  _hoisted_11,
                  (_unref(disabledCode) && disabledMail.value)
                    ? (_openBlock(), _createElementBlock("span", _hoisted_12, "(" + _toDisplayString(_unref(countDown)) + ")", 1))
                    : _createCommentVNode("", true)
                ]),
                _: 1
              }, 8, ["disabled", "loading"])
            ]),
            (_unref(isMobile))
              ? (_openBlock(), _createElementBlock("div", _hoisted_13))
              : _createCommentVNode("", true),
            (_unref(disabledCode) && disabledMail.value)
              ? (_openBlock(), _createElementBlock("p", _hoisted_14, "验证码已发送到邮箱：" + _toDisplayString(_unref(targetAddr)), 1))
              : _createCommentVNode("", true),
            (_unref(disabledCode) && disabledPhone.value)
              ? (_openBlock(), _createElementBlock("p", _hoisted_15, "验证码已发送到手机尾号：" + _toDisplayString(_unref(targetAddr)), 1))
              : _createCommentVNode("", true)
          ]),
          _: 1
        }, 8, ["max-height"])
      ]),
      _: 1
    }, 8, ["width", "modelValue"])
  ])), [
    [_directive_loading, _unref(MI_identify)]
  ])
}
}

})